import gql from "graphql-tag";
import { OrderInfoFragment, ParcelInfoFragment } from "./fragments";

export const AllParcelsSubscription = gql`
  subscription parcels($client_UID: ID) {
    parcels(client_UID: $client_UID) {
      ...ParcelInfo
    }
  }
  ${ParcelInfoFragment}
`;
export const AllOrderSubscription = gql`
  subscription orders($client_UID: ID!) {
    orders(client_UID: $client_UID) {
      ...OrderInfo
    }
  }
  ${OrderInfoFragment}
`;
